"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPropertiesSchema = exports.createDataSchema = exports.createWeakDataRef = exports.createDataRef = void 0;
const yup_1 = require("yup");
const thunderbolt_becky_types_1 = require("@wix/thunderbolt-becky-types");
const Core_schema_1 = require("./Core.schema");
thunderbolt_becky_types_1.enrich(yup_1.object);
const createDataRef = (schemas) => yup_1.string().meta({ schemas });
exports.createDataRef = createDataRef;
const createWeakDataRef = (schemaType) => yup_1.string().meta({ schemaType, weakRef: true });
exports.createWeakDataRef = createWeakDataRef;
const createSchema = (type, schema) => {
    const baseSchema = yup_1.object({
        id: yup_1.string().required(),
        type: yup_1.mixed().oneOf([type]).default(type),
    });
    return schema.concat(baseSchema);
};
exports.createDataSchema = createSchema;
const createPropertiesSchema = (type, schema) => createSchema(type, schema).concat(Core_schema_1.defaultProperties);
exports.createPropertiesSchema = createPropertiesSchema;
//# sourceMappingURL=schemaUtils.js.map